/*
import "@fontsource/montserrat";
import "@fontsource/montserrat/100.css";
import "@fontsource/montserrat/200.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/montserrat/900.css";
*/

import "@fontsource/dm-sans";
import "@fontsource/dm-sans/100.css";
import "@fontsource/dm-sans/200.css";
import "@fontsource/dm-sans/300.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/600.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/dm-sans/800.css";
import "@fontsource/dm-sans/900.css";

import "@fontsource/rethink-sans";
import "@fontsource/rethink-sans/400.css";
import "@fontsource/rethink-sans/500.css";
import "@fontsource/rethink-sans/600.css";
import "@fontsource/rethink-sans/700.css";
import "@fontsource/rethink-sans/800.css";

import 'react-image-gallery/styles/css/image-gallery.css';

export const onInitialClientRender = () => {
  if (process.env.GATSBY_THEME === "SESI") return;
  const m = document.createElement("meta");
  m.name = "adopt-website-id";
  m.content = "acb3adcc-974b-49b7-8ea9-990393f419fb";
  document.head.appendChild(m);
  const s = document.createElement("script");
  s.src = "https://tag.goadopt.io/injector.js?website_code=acb3adcc-974b-49b7-8ea9-990393f419fb";
  s.className = "adopt-injector";
  document.head.appendChild(s);
};
